import UpdateInvestorGoalError from './UpdateInvestorGoalError';
export default UpdateInvestorGoalError;
